// extracted by mini-css-extract-plugin
export default {"l_AlertIconBtn_main":"AlertIconBtn_l_AlertIconBtn_main__S4yr1"};